import { Injectable } from '@angular/core';
import { ApiContactsAdapterService } from '@fullyops/data/contacts/api-adapter.service';
import { Contact, ContactInput } from '@fullyops/data/contacts/contact';
import { MiniContact } from '@fullyops/data/contacts/mini-contact';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { map, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactsService {
  constructor(private api: ApiContactsAdapterService) {}

  private miniStore = createStore(
    { name: 'mini-contacts-store' },
    withEntities<MiniContact>({ idKey: 'id' }),
  );

  contacts$ = this.miniStore.pipe(selectAllEntities());

  create(input: ContactInput): Observable<string> {
    return this.api.create(input).pipe(map((res) => res.id));
  }

  createAndStore(input: ContactInput): Observable<string> {
    const sub = new Subject<string>();
    this.create(input).subscribe(sub);
    sub.subscribe((id) =>
      this.miniStore.update(
        addEntities({
          id,
          name: input.name,
          jobPosition: input.jobPosition,
          company: { id: input.companyId, name: '', nif: '' },
        }),
      ),
    );
    return sub;
  }

  getById(id: string): Observable<Contact> {
    return this.api.getById(id);
  }

  update(id: string, input: ContactInput): Observable<void> {
    return this.api.update(id, input);
  }

  delete(id: string): Observable<void> {
    return this.api.delete(id);
  }

  refreshMini(): void {
    this.api
      .getMini()
      .subscribe((res) => this.miniStore.update(setEntities(res)));
  }

  clearMini(): void {
    this.miniStore.update(deleteAllEntities());
  }
}
